export const API_ERROR_MESSAGES = {
  ATTENDANCE_PROOF_ALREADY_EXISTS: '이미 이 날짜의 출석을 인증했어요.',
  ATTENDANCE_PROOF_IMAGE_NOT_UPLOADED: '사진 업로드가 아직 끝나지 않았어요. 잠시 후 다시 시도해 주세요.',
  ATTENDANCE_PROOF_NOT_FOUND: '이 날짜의 출석 인증을 찾지 못했어요.',
  ATTENDANCE_PROOF_NOT_YET_ALLOWED: '설정한 출석 시간 5분 전부터 인증할 수 있어요.',
  AI_FEATURE_LEGAL_REQUIREMENTS_NOT_SATISFIED: 'AI 코칭 이용에 필요한 내용을 확인해 주세요.',
  COACHING_CONVERSATION_NOT_FOUND: '이 AI 코칭 대화를 찾지 못했어요. 대화 목록에서 다시 선택해 주세요.',
  COACHING_RESPONSE_ALREADY_IN_PROGRESS: 'AI 코치가 답변을 준비하고 있어요. 답변이 끝난 뒤 다시 시도해 주세요.',
  CORE_SERVICE_LEGAL_REQUIREMENTS_NOT_SATISFIED: '서비스 이용에 필요한 약관 및 정책 내용을 확인해 주세요.',
  CURRENT_LEGAL_DOCUMENT_NOT_FOUND: '현재 적용 중인 약관 또는 정책 문서를 찾지 못했어요.',
  DAILY_AMOUNT_INCREASE_NOT_ALLOWED: '이 화면에서는 오늘의 계획량을 늘릴 수 없어요.',
  DAILY_AMOUNT_LESS_THAN_COMPLETED_AMOUNT: '이미 완료한 분량보다 계획량을 작게 줄일 수 없어요.',
  DAILY_AMOUNT_TO_COMPLETE_EXCEEDS_DELAYED_AMOUNT: '남아 있는 이월 분량 안에서 완료량을 입력해 주세요.',
  DAILY_LOG_FOCUS_TIME_EXCEEDS_DURATION: '집중 시간은 전체 활동 시간보다 길 수 없어요.',
  DAILY_LOG_FOCUS_TIME_NOT_ALLOWED: '집중 시간은 학습 활동에만 기록할 수 있어요.',
  DAILY_LOG_NOT_FOUND: '이 하루 기록을 찾지 못했어요. 목록을 새로 확인해 주세요.',
  DAILY_LOG_SLEEP_TIME_TOO_SHORT: '수면 기록은 2시간 이상부터 남길 수 있어요.',
  DAILY_LOG_TIME_OVERLAPS: '같은 시간에 등록된 기록이 있어요. 시간을 조정해 주세요.',
  DAILY_LOG_TIME_RANGE_IN_FUTURE: '아직 지나지 않은 시간은 기록할 수 없어요.',
  DAILY_LOG_TIME_RANGE_TOO_LONG: '하나의 기록은 24시간을 넘길 수 없어요.',
  DAILY_QUANTITY_NOT_FOUND: '이 날짜의 계획을 찾지 못했어요. 계획을 다시 확인해 주세요.',
  DUPLICATE_LEGAL_DOCUMENT_ACTION_REQUEST: '같은 약관에 대한 응답이 중복되었어요. 내용을 다시 확인해 주세요.',
  EMAIL_ALREADY_EXISTS: '이미 가입된 이메일이에요. 로그인하거나 다른 이메일을 사용해 주세요.',
  EMAIL_ALREADY_VERIFIED: '이미 인증을 마친 이메일이에요.',
  EMAIL_NOT_VERIFIED: '이메일 인증을 먼저 완료해 주세요.',
  EMAIL_VERIFICATION_CODE_EXPIRED: '인증 번호가 만료됐어요. 새 번호를 받아 주세요.',
  EMAIL_VERIFICATION_CODE_MISMATCH: '인증 번호가 맞지 않아요. 다시 확인해 주세요.',
  EMAIL_VERIFICATION_NOT_FOUND: '진행 중인 이메일 인증을 찾지 못했어요. 인증 번호를 다시 받아 주세요.',
  EMAIL_VERIFICATION_RENEWAL_LIMIT_EXCEEDED: '인증 번호 요청 횟수를 모두 사용했어요. 잠시 후 다시 시도해 주세요.',
  EMAIL_VERIFICATION_RENEWAL_TOO_FREQUENT: '인증 번호를 방금 보냈어요. 잠시 기다린 뒤 다시 요청해 주세요.',
  EMPTY_COLLECTION: '한 가지 이상 내용을 적어 주세요.',
  FILE_CONTENT_TYPE_NOT_ALLOWED: 'JPG, PNG, WEBP 이미지 파일만 사용할 수 있어요.',
  FILE_SIZE_EXCEEDED: '파일 용량이 너무 커요. 안내된 최대 용량에 맞춰 주세요.',
  GOAL_NOT_FOUND: '아직 등록된 목표가 없어요.',
  IMAGE_ASSET_NOT_FOUND: '업로드한 이미지를 찾지 못했어요. 사진을 다시 선택해 주세요.',
  INVALID_DATE_RANGE: '시작과 종료 날짜를 다시 확인해 주세요.',
  INVALID_EMAIL_OR_PASSWORD: '이메일 또는 비밀번호가 맞지 않아요. 다시 확인해 주세요.',
  INVALID_INPUT_VALUE: '입력한 내용을 다시 확인해 주세요.',
  INVALID_LEGAL_DOCUMENT_ACTION_FOR_CONTEXT: '현재 화면에서 처리할 수 없는 약관 응답이에요. 최신 내용을 다시 확인해 주세요.',
  INVALID_LEGAL_DOCUMENT_ACTION_TYPE_FOR_INTERACTION_TYPE: '약관 응답 형식이 변경되었어요. 최신 내용을 다시 확인해 주세요.',
  INVALID_REFRESH_TOKEN: '로그인 정보가 유효하지 않아요. 다시 로그인해 주세요.',
  INVALID_REPORT_TYPE: '이 날짜에는 선택한 리포트를 작성할 수 없어요.',
  INVALID_SESSION_PERIOD: '학습 계획의 시작일과 종료일을 다시 확인해 주세요.',
  IN_PROGRESS_SESSIONAL_PLAN_LIMIT_EXCEEDED: '진행 중인 학습 계획은 최대 5개까지 만들 수 있어요.',
  LAST_DAILY_AMOUNT_REDUCTION_NOT_ALLOWED: '마지막 날의 계획량은 여기에서 줄일 수 없어요.',
  LAST_WEEKLY_QUANTITY_REDUCTION_NOT_ALLOWED: '마지막 주의 계획량은 여기에서 줄일 수 없어요.',
  LEGAL_DOCUMENT_ACTION_REQUEST_CONFLICT: '약관 응답 상태가 변경되었어요. 최신 내용을 확인한 뒤 다시 시도해 주세요.',
  LEGAL_DOCUMENT_NOT_FOUND: '요청한 약관 또는 정책 문서를 찾지 못했어요. 최신 내용을 다시 확인해 주세요.',
  MAX_LENGTH_EXCEEDED: '입력할 수 있는 글자 수를 넘었어요.',
  NICKNAME_ALREADY_EXISTS: '이미 사용 중인 닉네임이에요. 다른 이름을 입력해 주세요.',
  REPORT_ALREADY_EXISTS: '이 기간의 리포트가 이미 있어요. 기존 리포트를 확인해 주세요.',
  REPORT_DATE_IN_FUTURE: '아직 지나지 않은 날짜의 리포트는 작성할 수 없어요.',
  REPORT_NOT_FOUND: '이 리포트를 찾지 못했어요. 리포트 목록을 다시 확인해 주세요.',
  REQUIRED_LEGAL_DOCUMENT_ACTION_MISSING: '필수 약관 및 정책 내용을 모두 확인해 주세요.',
  SESSIONAL_PLAN_NOT_FOUND: '연결된 학습 계획을 찾지 못했어요. 학습 계획을 다시 확인해 주세요.',
  SESSION_NAME_ALREADY_EXISTS: '같은 이름의 학습 계획이 있어요. 다른 이름을 입력해 주세요.',
  SESSION_PERIOD_CHANGE_NOT_ALLOWED: '학습 항목이 등록된 계획은 기간을 바꿀 수 없어요.',
  SESSION_PERIOD_MAX_MONTHS_EXCEEDED: '학습 계획 기간은 최대 1년까지 설정할 수 있어요.',
  SUBJECT_NAME_ALREADY_EXISTS: '같은 이름의 학습 항목이 있어요. 다른 이름을 입력해 주세요.',
  TOTAL_AMOUNT_LESS_THAN_COMPLETED_AMOUNT: '전체 계획량은 이미 완료한 분량보다 작게 줄일 수 없어요.',
  TOTAL_QUANTITY_LIMIT_EXCEEDED: '하나의 학습 계획에는 학습 항목을 최대 50개까지 추가할 수 있어요.',
  TOTAL_QUANTITY_NOT_FOUND: '이 학습 항목을 찾지 못했어요. 목록을 새로 확인해 주세요.',
  USER_NOT_FOUND: '회원 정보를 찾지 못했어요. 입력한 정보를 확인하거나 다시 로그인해 주세요.',
  WEEKLY_AMOUNT_INCREASE_NOT_ALLOWED: '이 화면에서는 주간 계획량을 늘릴 수 없어요.',
  WEEKLY_AMOUNT_LESS_THAN_COMPLETED_AMOUNT: '이미 완료한 분량보다 주간 계획량을 작게 줄일 수 없어요.',
  WEEKLY_DELAY_AMOUNT_EXCEEDS_CURRENT_WEEKLY_DELAYED_AMOUNT: '남아 있는 이월 분량 안에서 옮길 양을 입력해 주세요.',
  WEEKLY_DELAY_RECEIVER_SAME_AS_SOURCE: '남은 분량은 다른 주로 옮겨 주세요.',
  WEEKLY_PLAN_ITEM_NOT_FOUND: '이 주간 계획 항목을 찾지 못했어요. 계획을 다시 확인해 주세요.',
  WEEKLY_PLAN_NOT_FOUND: '이 주의 학습 계획을 찾지 못했어요.',
  WEEKLY_QUANTITY_NOT_FOUND: '이 주간 계획을 찾지 못했어요. 계획을 다시 확인해 주세요.',

  // 인증 갱신 과정에서 사용되며 사용자에게 직접 노출될 수 있는 코드입니다.
  ACCESS_TOKEN_EXPIRED: '로그인 시간이 만료됐어요. 다시 로그인해 주세요.',
  REFRESH_TOKEN_EXPIRED: '로그인 시간이 만료됐어요. 다시 로그인해 주세요.',
}

const STATUS_ERROR_MESSAGES = {
  400: '입력한 내용을 다시 확인해 주세요.',
  401: '로그인이 필요해요. 다시 로그인해 주세요.',
  403: '이 작업을 진행할 권한이 없어요.',
  404: '요청한 정보를 찾지 못했어요. 화면을 새로 확인해 주세요.',
  408: '응답을 기다리는 시간이 길어지고 있어요. 다시 시도해 주세요.',
  409: '현재 상태와 요청이 맞지 않아요. 화면을 새로 확인한 뒤 다시 시도해 주세요.',
  413: '파일 용량이 너무 커요. 안내된 최대 용량에 맞춰 주세요.',
  415: '지원하지 않는 파일 형식이에요.',
  429: '요청이 잠시 몰렸어요. 조금 뒤에 다시 시도해 주세요.',
}

const DEFAULT_ERROR_MESSAGE = '요청을 마치지 못했어요. 잠시 후 다시 시도해 주세요.'
const SERVER_ERROR_MESSAGE = '서버에 일시적인 문제가 있어요.'
const OFFLINE_ERROR_MESSAGE = '인터넷 연결이 끊겼어요.'
const API_UNAVAILABLE_MESSAGE = 'akive 서버에 연결하지 못했어요.'
const REQUEST_ID_HEADER = 'x-request-id'
const REQUEST_ID_MAX_LENGTH = 128

function parseResponseData(data) {
  if (typeof data !== 'string') return data
  try {
    return JSON.parse(data)
  } catch {
    return data
  }
}

function normalizeRequestId(value) {
  if (typeof value !== 'string') return null
  const requestId = value.trim()
  if (!requestId) return null
  return requestId.slice(0, REQUEST_ID_MAX_LENGTH)
}

export function getApiRequestId(error) {
  const headers = error?.response?.headers
  if (!headers) return null

  try {
    if (typeof headers.get === 'function') {
      const requestId = normalizeRequestId(headers.get(REQUEST_ID_HEADER))
      if (requestId) return requestId
    }
  } catch {
    // 비표준 헤더 객체여도 일반 객체 접근 방식으로 한 번 더 확인한다.
  }

  return normalizeRequestId(
    headers[REQUEST_ID_HEADER] ?? headers['X-Request-Id'],
  )
}

export function getDisplayRequestId(error) {
  const status = error?.response?.status
  if (!Number.isInteger(status) || status < 500 || status > 599) return null
  return normalizeRequestId(error?.requestId) || getApiRequestId(error)
}

function appendRequestId(message, error) {
  const requestId = getDisplayRequestId(error)
  const reference = requestId ? `요청 식별자: ${requestId}` : ''
  if (!reference || message.includes(reference)) return message
  return `${message}\n${reference}`
}

export function getApiErrorCode(error) {
  const data = parseResponseData(error?.response?.data)
  return data && typeof data === 'object' ? data.code : undefined
}

export function getApiErrorMessage(error, fallback = DEFAULT_ERROR_MESSAGE) {
  if (error?.userMessage) return appendRequestId(error.userMessage, error)

  const code = getApiErrorCode(error)
  if (code && API_ERROR_MESSAGES[code]) {
    return appendRequestId(API_ERROR_MESSAGES[code], error)
  }

  if (!error?.response && (error?.request || error?.code === 'ERR_NETWORK' || error?.code === 'ECONNABORTED')) {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return OFFLINE_ERROR_MESSAGE
    }
    return API_UNAVAILABLE_MESSAGE
  }

  const status = error?.response?.status
  if (status >= 500) return appendRequestId(SERVER_ERROR_MESSAGE, error)
  if (STATUS_ERROR_MESSAGES[status]) return STATUS_ERROR_MESSAGES[status]
  return appendRequestId(fallback || DEFAULT_ERROR_MESSAGE, error)
}

export function normalizeApiError(error) {
  if (!error || typeof error !== 'object') return error

  error.requestId = getApiRequestId(error)
  const responseData = parseResponseData(error.response?.data)
  if (error.response && responseData && typeof responseData === 'object') {
    const serverMessage = responseData.message
    error.response.data = {
      ...responseData,
      ...(serverMessage ? { serverMessage } : {}),
      message: getApiErrorMessage({ ...error, response: { ...error.response, data: responseData } }),
    }
  }

  error.userMessage = getApiErrorMessage(error)
  error.message = error.userMessage
  return error
}
